import React from 'react'
import PropTypes from 'prop-types'
import flow from 'lodash/flow'
import translate from '../../i18n/Translate'

import SignIn from './SignIn'
import SignUp from './SignUp'
import ChangePassword from './ChangePassword'

const styles = {
  title: { fontWeight: 'lighter' },
  bg: {
    position: 'absolute',
    top:0,
    bottom:0,
    left:0,
    right:0,
    overflow:'hidden',
    background: 'url(/images/wallpaper-gray.jpg) no-repeat center center fixed',
    backgroundSize: 'cover'
  }
}

class Login extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      mode: 'signin',    //signin/signup/password,
    }
  }

  onModeChange = m => this.setState({ mode: m })

  render() {
    const { mode } = this.state
//    console.log(mode)

    return (
      <div style={styles.bg}>
        {
          mode === 'password'
          ? <ChangePassword onModeChange={this.onModeChange} { ...this.props }/>
          : (
            mode === 'signup'
              ? <SignUp onModeChange={this.onModeChange} { ...this.props } />
              : <SignIn onModeChange={this.onModeChange} { ...this.props }/>
            )
        }
      </div>
    )
  }
}

Login.propTypes = {
    strings: PropTypes.object
}

const decorators = flow([
  translate('Login')
])

export default decorators(Login)



// WEBPACK FOOTER //
// ./src/components/auth/Login.js